module.exports = __webpack_public_path__ + "static/media/working-capital.d6a6b619.svg";